import { Stack, TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { useEffect } from 'react';
import type { RootState } from '../../types/store';

type PlayerInfoFormProps = {
    onChangeName: Function;
};

export default function PlayerInfoForm({onChangeName} : PlayerInfoFormProps) {
    const translate = useSelector((state:RootState) => state.ui.language.common);
    const user = useSelector((state:RootState) => state.auth.user);
    
    useEffect(() => {
        if (user.nickname) {
            onChangeName(user.nickname);
        }
    }, []);
    
    function onUpdatePlayerInfo(e: React.ChangeEvent<HTMLInputElement>) {
        onChangeName(e.target.value);
    }

    return (
        <Stack gap={4}>
            <TextField placeholder={translate.enterName} label={translate.name} name="name" onChange={onUpdatePlayerInfo} defaultValue={user.nickname} />
        </Stack>
    );
}
